import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import Cookies from "js-cookie";
import { RetryOnError, verifyToken } from "../utilities/VerifyToken";
import { checkForAuthorization } from "utilities/index";

// export const FetchPipelineInvestors = ({ id, value, page = 1, limit = 10, sort = -1 }) => {
//     // console.log(id,"id")
//     // console.log(page.page,page.search,"page")
//     return useQuery(
//         ['master-listing-template-all-investors-rounds-fetch' + id + value, id, value, page, limit, sort],
//         () => {
//             let dynamicUrl = value === "invited" ? "getInvitePipelineInvestor" : "getPipelineInvestor";
//             return axios({
//                 method: 'get',
//                 url: `${process.env.REACT_APP_BASE_URL}/startups/${dynamicUrl}/${id}?page=${page}&limit=${limit}${sort != 0 ? `&sort=${sort}` : ''}`,
//                 headers: {
//                     'Authorization': `Bearer ${checkForAuthorization()}`
//                 },
//             })
//         }, {
//         // select: (data) => data,
//         select: (data) => {
//             console.log(data.data, "data")
//             return {
//                 data: data?.data?.data != undefined && data?.data?.data?.length > 0 ? data?.data?.data?.map(item => {
//                     // console.log(String(item?.investor_type)?.toLowerCase()?.includes("angel"), "fff")
//                     return ({
//                         ...item,
//                         name: item?.investor_type ? String(item?.investor_type)?.toLowerCase()?.includes("angel") ? item?.name : item?.organization_name : item?.name,
//                         //     // name: item?.investor_type ? String(item?.investor_type)?.toLowerCase()?.includes("angel") ? item?.personal_information : item?.organization_name : item?.personal_information,
//                         //     location: item?.city && item?.country ? `${item?.city},${item?.country}` : null,
//                         //     image: item?.profile_picture,
//                     })
//                 }) : [], count: data?.data?.count || 10, limit: data?.data?.limit || 10
//             }
//         },
//         refetchOnWindowFocus: false,
//         retry: (failureCount, error) => {
//             return RetryOnError(failureCount, error)
//         },
//         onError: (err) => {
//             return verifyToken(err)
//         },
//     })
// }

// PIPELINE INVESTORS

export const FetchPipelineInvestors = () => {
    return useMutation(
        ({ startup_id, value, page = 1, limit = 10, sort = -1, search = "", startup_round_id }) => {
            // console.log("Payload:", payload);
            // console.log("Startup ID:", startup_id);
            let dynamicUrl = value === "invited" ? "getInvitePipelineInvestor" : value === "interested" ? "getInterestedPipelineInvestor" : value === "rejected" ? "getRejectedPipelineInvestor" : value === "in-progress" ? "getInProgressPipelineInvestor" : "getInvitePipelineInvestor";
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/startups/${dynamicUrl}/${startup_id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`,
                    'Content-Type': 'application/json'
                },
                // data: payload
                data: {
                    page: page,
                    limit: limit,
                    sort: sort,
                    search: search,
                    startup_round_id: startup_round_id
                    // value: value
                }
            })
        }, {
        // onSuccess: (data)=>console.log("API successfull"),
        // retry: (failureCount, error)=>{
        //   return RetryOnError(failureCount, error)
        // },
        retry: 0,
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const FetchStatuses = ({startup_id}) => {
    return useQuery(
        [`get-pipeline-status-${startup_id}` ,startup_id],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/startups/get-pipeline-status/${startup_id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                }
            });
        },
        {
            select: (data) => {
                return data.data.data ? data.data.data.map(item => {
                    return {
                        ...item,
                        label: item?.status,
                        // mappedValue: item?.value,
                        // value: item?._id
                    }
                }) : [];
            },
            refetchOnWindowFocus: false,
            retry: (failureCount, error) => RetryOnError(failureCount, error),
            onError: (err) => verifyToken(err)
        }
    );
}

export const InviteInvestorToPipelineInvestors = () => {
    return useMutation(
        ({ payload, _id: startup_id }) => {
            // console.log("Payload:", payload);
            // console.log("Startup ID:", startup_id);
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/startups/pipelineInvestorInvite/${startup_id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`,
                    'Content-Type': 'application/json'
                },
                data: payload
            })
        }, {
        // onSuccess: (data)=>console.log("API successfull"),
        // retry: (failureCount, error)=>{
        //   return RetryOnError(failureCount, error)
        // },
        retry: 0,
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const ChangePipelineInvestorStatus = () => {
    return useMutation(
        ({ payload, pipeline_id }) => {
            // console.log("Payload:", payload);
            // console.log("Startup ID:", pipeline_id);
            return axios({
                method: 'put',
                url: `${process.env.REACT_APP_BASE_URL}/startups/pipelineInvestorStatus/${pipeline_id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`,
                    'Content-Type': 'application/json'
                },
                data: payload
            })
        }, {
        // onSuccess: (data)=>console.log("API successfull"),
        // retry: (failureCount, error)=>{
        //   return RetryOnError(failureCount, error)
        // },
        retry: 0,
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

//  add investor popup post api 
export const AddInvestorPopupPostApi = () => {
    return useMutation(
        ({ payload, _id }) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/startups/pipelineInvestorAdd/${_id}`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'application/json'
                },
                data: payload,
                // onUploadProgress: (data) => {
                //     setProgress(Math.round((data.loaded / data.total) * 100) == 100 ? 99 : Math.round((data.loaded / data.total) * 100));
                // }
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};

//  edit investor popup post api 
export const EditInvestorPopupPostApi = () => {
    return useMutation(
        ({ payload, _id }) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/startups/in-progress`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'application/json'
                },
                data: payload,
                // onUploadProgress: (data) => {
                //     setProgress(Math.round((data.loaded / data.total) * 100) == 100 ? 99 : Math.round((data.loaded / data.total) * 100));
                // }
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};


// INVESTED TAB
//  add investment startup portfolio post api 
export const CreateStartupPortfolioInvested = () => {
    return useMutation(
        ({ payload, _id }) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/startup-portfolio/create`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'application/json'
                },
                data: payload,
                // onUploadProgress: (data) => {
                //     setProgress(Math.round((data.loaded / data.total) * 100) == 100 ? 99 : Math.round((data.loaded / data.total) * 100));
                // }
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};

export const EditStartupPortfolioInvested = () => {
    return useMutation(
        ({ payload }) => {
            return axios({
                method: 'put',
                url: `${process.env.REACT_APP_BASE_URL}/startup-portfolio/edit`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'application/json'
                },
                data: payload,
                // onUploadProgress: (data) => {
                //     setProgress(Math.round((data.loaded / data.total) * 100) == 100 ? 99 : Math.round((data.loaded / data.total) * 100));
                // }
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};

export const FetchSelectedRoundDetails = () => {
    return useMutation(
        (payload) => {
            // console.log(payload, "payload"); // Removed excessive logging
            return axios.get(`${process.env.REACT_APP_BASE_URL}/startup-portfolio/get-round-details/${payload?.round_id}`, {
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`
                }
            });
        },
        {
            retry: (failureCount, error) => RetryOnError(failureCount, error),
            onError: (error) => verifyToken(error)
        }
    );
};

export const FetchInvestmentDetails = ({ investment_id }) => {
    // console.log(page.page,page.search,"page")
    return useQuery(
        ['master-FetchInvestmentDetails-FetchInvestmentDetails-FetchInvestmentDetails-fetch-view-FetchInvestmentDetails' + investment_id, investment_id],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/startup-portfolio/get-details/${investment_id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`,
                    // 'Cache-Control': 'no-cache, no-store, must-revalidate',
                    // Pragma: 'no-cache',
                    // Expires: '0',
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            const savedData = data?.data?.data;
            // console.log(data.data.data[0], 'datatatatat')
            const savedValues = {
                ...savedData,
                investor_type: savedData?.investor_id?.investor_type,
                email: savedData?.investor_id?.email,
                first_name: savedData?.investor_id?.personal_information?.first_name,
                last_name: savedData?.investor_id?.personal_information?.last_name,
                organization_name: savedData?.investor_id?.personal_information?.organization_name,
                round_id: savedData?.startup_round_id,
                documents: []
            }
            return savedValues
            // return { data: savedValues, status: savedData?.success }
        },
        refetchOnWindowFocus: false,
        retryDelay: 0,
        cacheTime: 0,
        // staleTime: 0,
        // refetchOnReconnect: true,
        enabled: !!investment_id,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const FetchInvestmentDocuments = ({ investment_id }) => {
    // console.log(page.page,page.search,"page")
    return useQuery(
        ['master-FetchInvestmentDocuments-FetchInvestmentDocuments-FetchInvestmentDocuments-fetch-view-FetchInvestmentDocuments' + investment_id, investment_id],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/startup-portfolio/get-listing-investment-document/${investment_id}`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`,
                    // 'Cache-Control': 'no-cache, no-store, must-revalidate',
                    // Pragma: 'no-cache',
                    // Expires: '0',
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            const savedData = data?.data?.data;
            // console.log(data.data.data, 'datatatatat')
            const savedValues = {
                // ...savedData,
                documents: savedData?.result
            }
            return savedValues
            // return { data: savedValues, status: savedData?.success }
        },
        refetchOnWindowFocus: false,
        retryDelay: 0,
        cacheTime: 0,
        // staleTime: 0,
        // refetchOnReconnect: true,
        enabled: !!investment_id,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const UploadInvestorDocumentsToDrive = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/startups/insert-drive-document`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'multipart/form-data'
                },
                data: payload,
                // onUploadProgress: (data) => {
                //     setProgress(Math.round((data.loaded / data.total) * 100) == 100 ? 99 : Math.round((data.loaded / data.total) * 100));
                // }
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};

export const DeleteInvestmentDocument = ({ investment_id }) => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'delete',
                url: `${process.env.REACT_APP_BASE_URL}/startup-portfolio/delete-documents/${investment_id} `,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'application/json'
                },
                data: payload
            });
        },
        {
            retry: 0,
            // onSuccess: (data)=>console.log("API successfull"),
            // retry: (failureCount, error)=>{
            //   return RetryOnError(failureCount, error)
            // },
            onError: (err) => {
                return verifyToken(err);
            }
        }
    );
};

export const DeleteInvestment = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'delete',
                url: `${process.env.REACT_APP_BASE_URL}/startup-portfolio/delete-startup-portfolio/${payload?.investment_id} `,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'application/json'
                },
                // data: payload
            });
        },
        {
            retry: 0,
            // onSuccess: (data)=>console.log("API successfull"),
            // retry: (failureCount, error)=>{
            //   return RetryOnError(failureCount, error)
            // },
            onError: (err) => {
                return verifyToken(err);
            }
        }
    );
};

// export const FetchInvestmentListing = ({ investment_id }) => {
//     // console.log(page.page,page.search,"page")
//     return useQuery(
//         ['master-FetchInvestmentListing-FetchInvestmentListing-FetchInvestmentListing-fetch-view-FetchInvestmentListing' + investment_id, investment_id],
//         () => {
//             return axios({
//                 method: 'get',
//                 url: `${process.env.REACT_APP_BASE_URL}/startup-portfolio/get-listing?page=${page}&limit=${limit}&sort=-1`,
//                 headers: {
//                     'Authorization': `Bearer ${checkForAuthorization()}`,
//                     // 'Cache-Control': 'no-cache, no-store, must-revalidate',
//                     // Pragma: 'no-cache',
//                     // Expires: '0',
//                 },
//             })
//         }, {
//         // select: (data) => data,
//         select: (data) => {
//             const savedData = data?.data?.data;
//             console.log(data, 'datatatatat')
//             // const savedValues = {
//             //     ...savedData,
//             //     investor_type: savedData?.investor_id?.investor_type,
//             //     email: savedData?.investor_id?.email,
//             //     first_name: savedData?.investor_id?.personal_information?.first_name,
//             //     last_name: savedData?.investor_id?.personal_information?.last_name,
//             //     round_id: savedData?.startup_round_id,
//             //     documents: []
//             // }
//             // return savedValues
//             return { data: [], status: savedData?.success }
//         },
//         refetchOnWindowFocus: false,
//         retryDelay: 0,
//         cacheTime: 0,
//         // staleTime: 0,
//         // refetchOnReconnect: true,
//         // enabled: !!investment_id,
//         retry: (failureCount, error) => {
//             return RetryOnError(failureCount, error)
//         },
//         onError: (err) => {
//             return verifyToken(err)
//         },
//     })
// }

export const FetchInvestmentListing = ({ id: startup_id, value, page = 1, limit = 10, sort = -1, search = "" }) => {
    // console.log(id,"id")
    // console.log(page.page,page.search,"page")
    return useQuery(
        ['FetchInvestmentListing-listing-FetchInvestmentListing-for-FetchInvestmentListing-FetchInvestmentListing--fetch' + startup_id + value, startup_id, value, page, limit, sort],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/startup-portfolio/get-listing/${startup_id}?page=${page}&limit=${limit}&sort=-1`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            const savedData = data?.data?.data?.data
            // const dataRoomsOptions = Array.isArray(savedData) ? savedData?.map((room) => {
            //     return ({
            //         label: room?.folder_name,
            //         value: room._id
            //     })
            // }) : [];
            // console.log(savedData, 'values new')
            return { data: savedData || [], count: data?.data?.data?.totalCount, limit: Number(limit) }
        },
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}